// extracted by css-extract-rspack-plugin
export default {"root":"SPEUXk","points-label":"GNg7I2","pointsLabel":"GNg7I2","points-bold":"C1nNr2","pointsBold":"C1nNr2","points-icon":"jf8SDP","pointsIcon":"jf8SDP"};